export const AXIOS_TIMEOUT: number = 30000;
export const POLLING_INTERVAL: number = 60000;
export const DEFAULT_POLYLINEWEIGHT: number = 4;
export const DEFAULT_ZOOM_LEVEL: number = 17;
export const DEFAULT_LAT: number = 41.1897;
export const DEFAULT_LNG: number = -96.0627;
export const HEADER: string = "PVR";
export const UNAUTHORIZED_LINK_EXPIRY_HEADER: string =
  "Link expired or invalid";
export const UNAUTHORIZED_LINK_EXPIRY_CONTENT: string =
  "Please request a new tracking link. ";
export const UNAUTHORIZED_SOMETHING_WENT_WRONG_HEADER: string =
  "Oops! Something went wrong";
export const UNAUTHORIZED_SOMETHING_WENT_WRONG_CONTENT: string =
  "We couldn't load the location trail.";
export const UNAUTHORIZED_NO_DATA_HEADER: string = "No location data available";
export const UNAUTHORIZED_NO_DATA_CONTENT: string =
  "Please try again later or refresh.";
export const LAST_UPDATED_TIME: string = "Last updated time";
export const DEFAULT_MAPID: string = "49ae42fed52588c3";
export const START_LOCATION: string = "Start Location";
export const CURRENT_LOCATION: string = "Current Location";
